import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import ReactPlayer from 'react-player'
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';

/** @class VideoUploader
 * A component for setting a media URL, either
 * with an existing online source or by uploading
 * the media to a Firebase storage bucket.
 */
export default class VideoUploader extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    this.state = {
      url: props.value,
      loading: false
    };
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleFileChange
    * Handles changes on the file input and
    * submits an updated url to the provided
    * onChange handler
    * @param {InputEvent} event - the event triggering
    * the update.
    */
  handleFileChange(event) {
    var file = event.target.files[0];
    var key = firebase.database().ref('/uploads').push().key;
    var ref = firebase.storage().ref().child(`/uploads/${key}/${file.name}`);
    this.setState({loading: true});
    ref.put(file).then(()=>{
      ref.getDownloadURL().then((url) => {
        this.setState({loading: false, url: url});
        this.props.onUpload(this.state.url);
      });
    });
  }
  /** @method handleRemove
    * Removes the media from firebase storage (if held there)
    * and removes the url from the database.
    */
  handleRemove(event) {
    //var ref = firebase.storage().ref().child(this.props.dataURL);
    //ref.delete().catch(err => console.error(err.message));
    this.props.onUpload(null);
  }
  /** @function handleBlur
    * Sends the state update back to the parent
    */
  handleBlur() {
    this.props.onUpload(this.state.url);
  }
  /** @function render
    * Renders the component
    */
  render() {
    const remove = (
      <button onClick={this.handleRemove}>
        <FontAwesome name="times-circle" style={{color: 'red', padding: '0', marginRight: '0.5rem'}} />
        Remove Media
      </button>
    )
    const input = (
      <div className="spinner-box">
        <input type="url" name="url"
          value={this.state.url}
          onChange={this.handleChange}
          onBlur={this.handleBlur} />
        <input type="file" name="media" onChange={this.handleFileChange}/>
        <ReactPlayer url={this.props.value} controls style={{maxWidth:"100%"}}/>
        {(this.props.value) ? remove : null}
      </div>
    );
    const spinner = (<span><FontAwesome name="spinner" spin={true}/>Loading...</span>);
    return(
      <div>
        <label htmlFor="url">{this.props.name} URL</label>
        <div className="uploader-input">
          {(this.state.loading) ? spinner : input}<br />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uploaders/video-uploader.js